import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';
import {HttpStatusCode} from 'axios';
import Modal from '@mui/material/Modal';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
// import {FormControl, FormGroup} from '@mui/material';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import {withStyles} from '@mui/styles';
import SearchIcon from '@mui/icons-material/Search';
import CheckCircle from '@mui/icons-material/CheckCircle';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';

import {commonOperations} from '../../../../reducks/common';
import {senroCodeOperations} from '../../../../reducks/senroCode';
import {searchMap, getNewNwOfficeMap, searchCheck} from '../../../../common/common.js';
import {CATEGORY_TYPE} from '../../../../common/commonConst.js';
import {getKbnList, sysErr} from '../../../../common/commonGmn.js';
import {postRequest} from '../../../../common/backend.js';
import PaperPart from '../../../atoms/PaperPart.js';
import {/* renderCheckbox,*/ renderTextField, renderSelect} from '../../../atoms/CustomPart.js';
import PositiveButton from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import FooterButton from '../../../organisms/FooterButton.js';
import withRouter from '../../../organisms/withRouter.js';
import CustomFlexGrid, {createComponents} from '../../../molecules/CustomFlexGrid.js';
import CustomAccordion from '../../../molecules/Accordion.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import * as validateRule from '../../../validateRule.js';

const styles = (theme) => ({
  modal: {
    top: '5%',
    left: '5%',
    right: '5%',
    bottom: '5%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    padding: '8px 0px 16px 0px',
    backgroundColor: '#fafafa',
    maxHeight: '100%',
    height: 'auto',
    overflow: 'auto',
  },
  condition: {
    'padding': '4px 0 16px 0',
    '& form .MuiPaper-root.MuiAccordion-root': {
      marginBottom: '8px',
    },
  },
  period: {
    lineHeight: 3.5,
    margin: '0 -8px 0 20px',
  },
});

// お客さま情報
const gridItems = [
  {binding: 'oldNwOffice', header: 'NW事業所', dataType: 'String', width: 120, isReadOnly: true},
  {binding: 'ciKkyTtnTtNo', header: '供給地点特定番号', dataType: 'String', width: 160, isReadOnly: true},
  {binding: 'jtJkt', header: 'ご契約番号', dataType: 'String', width: 130, isReadOnly: true},
  {binding: 'juJysKngMei', header: 'お客さま名', dataType: 'String', width: 150, isReadOnly: true},
  {binding: 'juJysKnaMei', header: 'お客さま名カナ', dataType: 'String', width: 150, isReadOnly: true},
  {binding: 'blockNo', header: '区画番号', dataType: 'String', width: 150, isReadOnly: true},
  {binding: 'pillarDntNo', header: '電柱番号', dataType: 'String', width: 200, isReadOnly: true},
  {binding: 'tiKkySrtYmd', header: '供給開始年月日', dataType: 'String', width: 150, isReadOnly: true},
  {binding: 'tiIdoYmd', header: '異動年月日', dataType: 'String', width: 150, isReadOnly: true},
  {binding: 'surveyManagementCategory', header: '調査管理区分', dataType: 'String', width: 150, isReadOnly: true},
  {binding: 'surveyIndustry', header: '調査業種', dataType: 'String', width: 110, isReadOnly: true},
  {binding: 'surveyReason', header: '調査理由', dataType: 'String', width: 150, isReadOnly: true},
  {binding: 'kyKyJok', header: '契約状況', dataType: 'String', width: 110, isReadOnly: true},
  {binding: 'kyCpsSvm', header: 'サービスメニュー', dataType: 'String', width: 170, isReadOnly: true},
  {binding: 'lastSurveyFiscalYear', header: '前回調査年度', dataType: 'String', width: 150, isReadOnly: true},
  {binding: 'nextSurveyFiscalYear', header: '次回調査年度', dataType: 'String', width: 150, isReadOnly: true},
  {binding: 'lastSurveyCheckConsignArea', header: '前回委託エリア', dataType: 'String', width: 150, isReadOnly: true},
  // {binding: 'nextSurveyCheckConsignArea', header: '次回委託エリア', dataType: 'String', width: 150, isReadOnly: true},
];

const footerItems = [
  {type: 'positive', key: 'keySCZ1012Select', label: '選択', click: null, size: 'medium', startIcon: <CheckCircle />, disabled: true},
  {type: 'negative', key: 'keySCZ1012Close', label: '閉じる', click: null, size: 'medium', startIcon: <KeyboardReturnIcon />},
];

/**
 * お客さま情報選択画面
 * 画面ID:SCZ1012
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonDisabled: true,
      warningMessages: [],
      senros: [],
    };
    this.senroMs = null;
    this.gridRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    this._initialValue();
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
  }

  /**
   * 画面項目初期化
   */
  _initialValue = async () => {
    const {userInfo} = this.props;

    try {
      let valid = userInfo.authNwOfficeCodes?.includes(userInfo.nwOfficeCode);
      let nwOfficeCode = valid ? userInfo.nwOfficeCode : null;
      this.props.change('nwOfficeCode', nwOfficeCode);
      let senros = await this._masterLine(nwOfficeCode);
      this.setState({
        warningMessages: [],
        senros: senros,
      });
    } catch (error) {
      sysErr(this.props);
    }
  };

  /**
   * フッタ設定
   */
  setFooterItems = () => {
    [{
      click: this.doSelect,
      props: this.props,
      disabled: this.state.buttonDisabled,
    }, {
      click: this.doBack,
    }].forEach((attr, i) => {
      footerItems[i] = {...footerItems[i], ...attr};
    });
  };

  /**
    * 線路マスタ一覧 取得
    * @param {string} nwOfficeCode NW事業所コード
    * @return {Promise<AxiosResponse<any>>} 取得結果一覧
    */
  _masterLine = async (nwOfficeCode) => {
    const {userInfo} = this.props;

    let _body = {
      condition: {
        nwOfficeCodes: [nwOfficeCode || userInfo.nwOfficeCode],
      },
      // 権限todo
      surveyCompanyCode: userInfo.corpCd,
      nwOfficeCodes: userInfo.authNwOfficeCodes,
    };

    // 線路リスト取得
    let _url = 'common/get-master-line';
    const response = await postRequest(_url, _body);
    if (response.status != HttpStatusCode.Ok) {
      if (response.data?.message != null) {
        this.props.doShowMessage({
          message: {
            id: response.data?.message.id,
            text: response.data?.message.text,
          },
        });
      }
      return [];
    }
    return response.data.masterLine || [];
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    await this.props.reset();
    this._initialValue();
    this.senroMs = null;
    this.gridRef.current.setItemsSource([]);
  };

  /**
   * 検索ボタン押下時処理
   * @param {*} values
   */
  doSearch = async (values) => {
    const {userInfo} = this.props;
    try {
      this.gridRef = {};
      let _body = {
        searchCondition: values,
        // 権限todo
        surveyCompanyCode: userInfo.corpCd,
        nwOfficeCodes: userInfo.authNwOfficeCodes,
      };

      // 検索実行
      let _url = 'scz1012/search-customer';
      const response = await postRequest(_url, _body);
      if (response.status != HttpStatusCode.Ok) {
        if (response.data?.message != null) {
          this.props.doShowMessage({
            message: {
              id: response.data?.message.id,
              text: response.data?.message.text,
            },
          });
        }
        return;
      }

      // 件数チェック
      let _warningMessages = searchCheck(response.data.customerList);
      this.setState({warningMessages: _warningMessages});

      // 結果設定
      if (this.gridRef?.current) {
        this.gridRef.current.setItemsSource(response.data.customerList);
      }
    } catch (error) {
      sysErr(this.props);
    }
  };

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let selected = (this.gridRef?.current?.selectedItemCount() > 0);
      this.setState({buttonDisabled: !selected});
    } catch (error) {
      sysErr(this.props);
    }
  };

  /**
   * NW事業所 イベント（change）
   * @param {*} _ イベント
   * @param {*} v 値
   */
  handleNwOfficeCodeChange = async (_, v) => {
    this.senroMs = null;
    this.props.change('senroCd', '');
    this.props.change('kansnNo', '');
    this.props.change('bunk1No', '');
    this.props.change('bunk2No', '');
    this.props.change('bunk3No', '');
    this.props.change('bunki', '');
    this.setState({
      senros: await this._masterLine(v),
    });
  };

  /**
   * 線路名カナ イベント（blur）
   * @param {*} e イベント
   */
  handleSenroNameChange = async (e) => {
    let senro = e.target.value.split(':');
    if (senro.length != 2) {
      senro = [this.props.values.senroCd, senro[0]];
    }

    // 線路データ検索
    let senros = this.state.senros.filter((data) =>
      senro[1].length > 0 &&
      data.senroCd === senro[0].trim() &&
      data.senroMskn === senro[1].trim());

    // 幹線／分岐データクリア
    if (senros.length == 0) {
      this.props.change('kansnNo', '');
      this.props.change('bunk1No', '');
      this.props.change('bunk2No', '');
      this.props.change('bunk3No', '');
      this.props.change('bunki', '');
    }

    // 線路コード／線路名設定
    this.senroMs = senros[0]?.senroMskn;
    this.props.change('senroMs', senros[0]?.senroMskn || '');
    this.props.change('senroCd', senros[0]?.senroCd || '');
  };

  /**
   * ボタン - 選択
   */
  doSelect = () => {
    let gridData = this.gridRef.current.selectedItem();
    this.props.selectButton(gridData);
  };

  /**
   * ボタン - 閉じる
   */
  doBack = () => {
    this.props.reset();
    this.props.closeButton();
  };

  /**
   * 要素生成 - 検索条件
   * @return {React.JSX.Element|null}
   */
  renderCondition() {
    const {classes, genericMap, userInfo} = this.props;
    const genericItems = {};
    [
      CATEGORY_TYPE.SURVEY_MANAGEMENT_CATEGORY_CODE,
      CATEGORY_TYPE.SURVEY_INDUSTRY_CODE,
      CATEGORY_TYPE.SURVEY_REASON_CODE,
      CATEGORY_TYPE.KY_KY_JOK_KBN,
      CATEGORY_TYPE.KY_CPS_SVM_CD,
      CATEGORY_TYPE.SURVEY_CHECK_CONSIGN_AREA_CODE,
    ].forEach((type) => {
      genericItems[type] = getKbnList(searchMap(genericMap, type));
    });

    let nwOfficeList = getKbnList(
        getNewNwOfficeMap(genericMap, userInfo.authNwOfficeCodes));

    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="keySCZ1012nwOfficeCode" item xs={12} sm={2}>
            <Field
              id="nwOfficeCode"
              name="nwOfficeCode"
              component={renderSelect}
              className="fields"
              label="NW事業所"
              fullWidth
              required={false}
              onChange={this.handleNwOfficeCodeChange}
              InputProps={{
                readOnly: false,
              }}
            >
              {nwOfficeList}
            </Field>
          </Grid>
          <Grid key="keySCZ1012ciKkyTtnTtNo" item xs={12} sm={2}>
            <Field
              id="ciKkyTtnTtNo"
              name="ciKkyTtnTtNo"
              component={renderTextField}
              className="fields"
              label="供給地点特定番号"
              fullWidth
              type="text"
              required={false}
            />
          </Grid>
          <Grid key="keySCZ1012jtJkt" item xs={12} sm={2}>
            <Field
              id="jtJkt"
              name="jtJkt"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="ご契約番号"
              fullWidth
              type="text"
              required={false}
            />
          </Grid>
          <Grid key="keySCZ1012juJysKngMei" item xs={12} sm={2}>
            <Field
              id="juJysKngMei"
              name="juJysKngMei"
              component={renderTextField}
              className="fields"
              label="お客さま名"
              fullWidth
              type="text"
              required={false}
            />
          </Grid>
          <Grid key="keySCZ1012juJysKnaMei" item xs={12} sm={2}>
            <Field
              id="juJysKnaMei"
              name="juJysKnaMei"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="お客さま名カナ"
              fullWidth
              type="text"
              required={false}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="keySCZ1012tiKkySrtYmdFrom" item xs={12} sm={2}>
            <Field
              id="tiKkySrtYmdFrom"
              name="tiKkySrtYmdFrom"
              component={renderTextField}
              className="fields"
              fullWidth
              label="供給開始年月日"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Typography className={classes.period}>～</Typography>
          <Grid key="keySCZ1012tiKkySrtYmdTo" item xs={12} sm={2}>
            <Field
              id="tiKkySrtYmdTo"
              name="tiKkySrtYmdTo"
              component={renderTextField}
              className="fields"
              fullWidth
              // label="供給開始年月日"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid key="keySCZ1012tiIdoYmdFrom" item xs={12} sm={2}>
            <Field
              id="tiIdoYmdFrom"
              name="tiIdoYmdFrom"
              component={renderTextField}
              className="fields"
              fullWidth
              label="異動年月日"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Typography className={classes.period}>～</Typography>
          <Grid key="keySCZ1012tiIdoYmdTo" item xs={12} sm={2}>
            <Field
              id="tiIdoYmdTo"
              name="tiIdoYmdTo"
              component={renderTextField}
              className="fields"
              fullWidth
              // label="異動年月日"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="keySCZ1012surveyManagementCategoryCode" item xs={12} sm={2}>
            <Field
              id="surveyManagementCategoryCode"
              name="surveyManagementCategoryCode"
              component={renderSelect}
              className="fields"
              label="調査管理区分"
              fullWidth
              required={false}
              InputProps={{
                readOnly: false,
              }}
            >
              {genericItems[CATEGORY_TYPE.SURVEY_MANAGEMENT_CATEGORY_CODE]}
            </Field>
          </Grid>
          <Grid key="keySCZ1012surveyIndustryCode" item xs={12} sm={2}>
            <Field
              id="surveyIndustryCode"
              name="surveyIndustryCode"
              component={renderSelect}
              className="fields"
              label="調査業種"
              fullWidth
              required={false}
              InputProps={{
                readOnly: false,
              }}
            >
              {genericItems[CATEGORY_TYPE.SURVEY_INDUSTRY_CODE]}
            </Field>
          </Grid>
          <Grid key="keySCZ1012surveyReasonCode" item xs={12} sm={2}>
            <Field
              id="surveyReasonCode"
              name="surveyReasonCode"
              component={renderSelect}
              className="fields"
              label="調査理由"
              fullWidth
              required={false}
              InputProps={{
                readOnly: false,
              }}
            >
              {genericItems[CATEGORY_TYPE.SURVEY_REASON_CODE]}
            </Field>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="keySCZ1012blockNoFrom" item xs={12} sm={2}>
            <Field
              id="blockNoFrom"
              name="blockNoFrom"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="区画番号"
              fullWidth
              type="text"
              required={false}
            />
          </Grid>
          <Typography className={classes.period}>～</Typography>
          <Grid key="keySCZ1012blockNoTo" item xs={12} sm={2}>
            <Field
              id="blockNoTo"
              name="blockNoTo"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="区画番号"
              fullWidth
              type="text"
              required={false}
            />
          </Grid>
          <Grid key="keySCZ1012kyKyJokKbn" item xs={12} sm={2}>
            <Field
              id="kyKyJokKbn"
              name="kyKyJokKbn"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="契約状況"
              fullWidth
              required={false}
              InputProps={{
                readOnly: false,
              }}
            >
              {genericItems[CATEGORY_TYPE.KY_KY_JOK_KBN]}
            </Field>
          </Grid>
          <Grid key="keySCZ1012kyCpsSvmCd" item xs={12} sm={4}>
            <Field
              id="kyCpsSvmCd"
              name="kyCpsSvmCd"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="サービスメニュー"
              fullWidth
              required={false}
              InputProps={{
                readOnly: false,
              }}
            >
              {genericItems[CATEGORY_TYPE.KY_CPS_SVM_CD]}
            </Field>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="keySCZ1012lastSurveyFiscalYear" item xs={12} sm={2}>
            <Field
              id="lastSurveyFiscalYear"
              name="lastSurveyFiscalYear"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="前回調査年度"
              fullWidth
              type="text"
              required={false}
            />
          </Grid>
          <Grid key="keySCZ1012nextSurveyFiscalYear" item xs={12} sm={2}>
            <Field
              id="nextSurveyFiscalYear"
              name="nextSurveyFiscalYear"
              // variant="standard"
              component={renderTextField}
              className="fields"
              label="次回調査年度"
              fullWidth
              type="text"
              required={false}
            />
          </Grid>
          <Grid key="keySCZ1012lastSurveyCheckConsignAreaCode" item xs={12} sm={2}>
            <Field
              id="lastSurveyCheckConsignAreaCode"
              name="lastSurveyCheckConsignAreaCode"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="前回委託エリア"
              fullWidth
              required={false}
              InputProps={{
                readOnly: false,
              }}
            >
              {genericItems[CATEGORY_TYPE.SURVEY_CHECK_CONSIGN_AREA_CODE]}
            </Field>
          </Grid>
          {/* TODO 第Ⅱ期
          <Grid key="keySCZ1012nextSurveyCheckConsignAreaCode" item xs={12} sm={2}>
            <Field
              id="nextSurveyCheckConsignAreaCode"
              name="nextSurveyCheckConsignAreaCode"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="次回委託エリア"
              fullWidth
              required={false}
              InputProps={{
                readOnly: false,
              }}
            >
              {genericItems[CATEGORY_TYPE.SURVEY_CHECK_CONSIGN_AREA_CODE]}
            </Field>
          </Grid>
          <Grid key="everyYearTs" item xs={12} sm={2}>
            <FormControl component="fieldset" className="formControl">
              <FormGroup row={true}>
                <Field className="checkbox"
                  id="everyYearTs"
                  name="everyYearTs"
                  component={renderCheckbox}
                  label="調査会社固定"
                  onChange={this._handleChangeCheckbox}
                  // isChecked="true"
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                />
              </FormGroup>
            </FormControl>
          </Grid> */}
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="keySCZ1012senroCd" item xs={12} sm={1}>
            <Field
              id="senroCd"
              name="senroCd"
              component={renderTextField}
              className="fields"
              label="線路コード"
              fullWidth
              type="text"
              required={false}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid key="keySCZ1012senroMs" item xs={12} sm={3}>
            <Autocomplete
              id="autocompleteSenroName"
              options={this.state.senros?.map((option) => option.senroCd + ': ' + option.senroMskn)}
              noOptionsText=''
              size='small'
              fullWidth
              className="dntFields"
              value={this.senroMs}
              onBlur={this.handleSenroNameChange}
              renderInput={(params) => (
                <Field
                  id="senroMs"
                  name="senroMs"
                  component={renderTextField}
                  label="線路名"
                  required={false}
                  {...params}
                />
              )}
            />
          </Grid>
          <Grid key="keySCZ1012kansnNo" item xs={12} sm={1}>
            <Field
              id="kansnNo"
              name="kansnNo"
              component={renderTextField}
              className="dntFields"
              label="幹線"
              fullWidth
              type="text"
              required={false}
            />
          </Grid>
          <Grid key="keySCZ1012bunk1No" item xs={12} sm={1}>
            <Field
              id="bunk1No"
              name="bunk1No"
              component={renderTextField}
              className="dntFields"
              label="第１分岐"
              fullWidth
              type="text"
              required={false}
            />
          </Grid>
          <Grid key="keySCZ1012bunk2No" item xs={12} sm={1}>
            <Field
              id="bunk2No"
              name="bunk2No"
              component={renderTextField}
              className="dntFields"
              label="第２分岐"
              fullWidth
              type="text"
              required={false}
            />
          </Grid>
          <Grid key="keySCZ1012bunk3No" item xs={12} sm={1}>
            <Field
              id="bunk3No"
              name="bunk3No"
              component={renderTextField}
              className="dntFields"
              label="第３分岐"
              fullWidth
              type="text"
              required={false}
            />
          </Grid>
          <Grid key="keySCZ1012bunki" item xs={12} sm={2}>
            <Field
              id="bunki"
              name="bunki"
              component={renderSelect}
              className="dntFields"
              label="分岐有無"
              fullWidth
              required={false}
              sx={{width: '120px'}}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={0}>{'分岐なし'}</MenuItem>
              <MenuItem value={1}>{'分岐あり'}</MenuItem>
            </Field>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: this.props.selectMode || 'check',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      counterOn: false,
      isDisplayCount: true,
      AddDeleteOn: false,
      style: {maxHeight: '300px', maxWidth: '100%', height: 'auto', width: 'auto'},
      isReadOnly: true,
      checkedFunction: this.checkStateUpdate,
    };
    const component = createComponents(gridItems, true);
    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {component}
      </CustomFlexGrid>
    );
  }

  /**
   * 画面描画
   * @return {*}
   */
  render() {
    const {classes, handleSubmit} = this.props;
    this.setFooterItems();
    return (
      <Modal
        open={this.props.modalOpen}
        className={classes.modal}
      >
        <PaperPart className={classes.content}>
          <Typography variant='h6' sx={{fontWeight: 'bold'}}>お客さま情報選択</Typography>
          <Grid key="keySCZ1012Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages} />
          </Grid>
          <PaperPart className={classes.condition}>
            <form noValidate autoComplete="off" className={classes.root}>
              <CustomAccordion
                title='検索条件'
                items={[this.renderCondition()]}
                defaultExpanded={true} />
            </form>
            <Grid
              container
              justifyContent="right"
              alignItems="right"
              spacing={1}
            >
              <Grid key="keySCZ1012clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  onClick={this._reset}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="keySCZ1012search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '20px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '4px'}} />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid key="keySCZ1012List" item xs={12}>
              {this.renderTable()}
            </Grid>
          </Grid>
          <FooterButton components={footerItems} _props={this.props} />
        </PaperPart>
      </Modal>
    );
  }
}

/**
 * フォーム共通Validate処理。
 *
 * 項目単体では実施できないValidateを行う。
 * ・開始日と終了日の整合性チェック
 *
 * @param {object} values 入力値情報
 * @return {object} エラー情報。キー:項目名、値:エラー内容
 */
const validate = (values) => {
  const errors = {};

  // 開始日と終了日の整合性チェック
  Object.assign(errors, isCorrectDataFromTo(values));

  return errors;
};

/**
 * 開始日と終了日の整合性チェック
 *
 * @param {object} values 入力値情報
 * @return {object} エラー情報。キー:項目名、値:エラー内容
 */
const isCorrectDataFromTo = (values) => {
  const errors = {};
  if (values === undefined || values === null) {
    return errors;
  }

  [
    // 供給開始年月日（自至）
    {from: 'tiKkySrtYmdFrom', to: 'tiKkySrtYmdTo'},
    // 異動年月日（自至）
    {from: 'tiIdoYmdFrom', to: 'tiIdoYmdTo'},
  ].forEach((item) => {
    const valueFrom = values[item.from];
    const valueTo = values[item.to];
    errors[item.from] = validateRule.correctFromDate(valueTo)(valueFrom);
    errors[item.to] = validateRule.correctDate(valueFrom)(valueTo);
  });

  return errors;
};

Container.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  selectMode: PropTypes.object,
  closeButton: PropTypes.func.isRequired,
  selectButton: PropTypes.func.isRequired,
  classes: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  genericMap: PropTypes.object,
  history: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doGetSenroCodeList: PropTypes.func,
  doShowMessage: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetInitValues: PropTypes.func,
  change: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    genericMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
  };
};

const mapDispatchToProps = {
  doGetSenroCodeList: senroCodeOperations.doGetSenroCodeList,
  doShowMessage: commonOperations.doShowMessage,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'SCZ1012FORM';
Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
  validate: validate,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
